/**
 * GlassCard — DS Organism pivot
 * Composant glassmorphism fondamental du DS
 */

import styles from './GlassCard.module.css';

interface GlassCardProps {
  children: React.ReactNode;
  strong?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function GlassCard({ children, strong = false, padding = 'md', className = '' }: GlassCardProps) {
  return (
    <div className={`${styles.card} ${strong ? styles.strong : ''} ${styles[`pad-${padding}`]} ${className}`}>
      {children}
    </div>
  );
}
